<div [class.open]="isSelectListShow" class="select_list">
    <div #select_header (click)="isSelectListShow = !isSelectListShow" class="header">
        <span [innerHTML]="selected.length || invite_list.length ? selectedRow() : 'MAIN_MENU.NOT_SELECTED' | translate"></span>
        <i class="icon-down"></i>
    </div>
    <div #select_body *ngIf="isSelectListShow" [@fade]="'in'" class="list">
        <div style="padding: 5px 10px;">
            <input [formControl]="query" placeholder="Поиск" type="text">
        </div>
        <ng-container *ngFor="let item of row2; let i = index">
            <label (click)="removeEmail(i)" [class.selected]="item.selected">
                <span>{{ item["email"] }}</span>
            </label>
        </ng-container>
        <ng-container *ngFor="let item of filteredUsers; let i = index">
            <label (click)="selectItems(item)" [class.selected]="item.selected">
                <span [class.blocked_user]="item.project_setting.observation_type === 'blocked'"
                      [class.inactive_user]="!item.is_active"
                >
                    <img *ngIf="item.project_setting.is_project_admin"
                         alt="#"
                         ngbTooltip="{{ 'USERS_PROFILE.ROLE.AMIN' | translate }}"
                         src="../../../../../assets/images/admin.svg">
                    {{ helper.fullName(item) }}
                </span>
            </label>
        </ng-container>
        <ng-container *ngIf="(!row || !row.length || !filteredUsers.length) && (!row2 || !row2.length)">
            <label>
                <span>
                    <b>Результатов нет</b>
                </span>
            </label>
            <!--<div style="padding: 5px 10px;" *ngIf="limit ? invite_list.length + row2.length + selected.length < limit : true">
                <button class="button" (click)="setInviteList(query.value)">
                    <span>Пригласить по почте</span>
                </button>
            </div>-->
        </ng-container>
    </div>
</div>
<!--
<ng-container *ngIf="invite_list.length">
    <div class="invited_users__block">
        <h2>Данные о приглашаем{{invite_list.length > 1 ? 'ых' : 'ом'}}
            пользовател{{invite_list.length > 1 ? 'ях' : 'е'}}:
        </h2>
        <ng-container *ngFor="let item of invite_list">
            <div (click)="item.opened = !item.opened" class="invited_user__title"
                 [class.completed]="item.completed">
                <i [class.rotate]="item.opened"
                   [class.icon-check]="item.completed && !item.opened"
                   [class.icon-plus]="!item.completed || item.opened"></i>
                <span>
                {{item.email}}
            </span>
            </div>
            <div class="invited_user" [formGroup]="item.formGroup"
                 [class.opened]="item.opened" [class.completed]="item.completed">
                <label>Роль пользователя</label>
                <app-default-select
                        [disable]="item.completed"
                        (selectedVal)="selectedValueByInvited(item, 'observ', $event)"
                        [row]="helper.returnRoleList">
                </app-default-select>
                <label>Комментарий</label>
                <input [class.disabled]="item.completed" formControlName="position" type="text">
                <div class="p-3 w-100" *ngIf="!item.completed">
                    <button class="button blue w-100"
                            (click)="completeInvite(item);"
                            [disabled]="!item.formGroup.valid">
                        <span>Применить</span>
                    </button>
                </div>
                <div class="p-3 w-100" *ngIf="item.completed">
                    <button class="button orange w-100"
                            (click)="completeInvite(item);">
                        <span>Изменить</span>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
</ng-container>
-->
